<script setup>

</script>

<template>
  <div v-if="sesionAb === 1" class="layout no-zoom" @click="onWrapperClick">
    {{ start() }}
    <DateOverride v-if="isAllowedEnvironment" @date-changed="onDateChanged" />
    <MenuComponent :userData="datosUsuario" @logout="CerrarLogin" />
    <div class="layout-main">
      <router-view />
    </div>
    <AppFooter :isLogin="false" @show-changelog="showChangelogDialog" />
    <changelog-dialog v-model:visible="isChangelogVisible" />
  </div>
  <!--LOGIN-->
  <div v-else>
    <Login @login-success="onLoginSuccess" :mensaje="mensaje" />
  </div>
</template>

<script>
import MenuComponent from './components/Menu.vue'; // Import the new MenuComponent
import EmpleadosServicio from './service/EmpleadosServicio';
import Login from './pages/Login.vue'; // Updated import path
import DateOverride from './components/DateOverride.vue'; // Import DateOverride component
import AppFooter from './components/Footer.vue'; // Corregido: usar ruta relativa correcta
import ChangelogDialog from './components/dialogs/ChangelogDialog.vue';

export default {
  data() {
    return {
      sesionAb: null,
      tim: 0,
      noUsu: 0,
      cerrarSesion: false,
      timer: null,
      time: 0,
      hora: null,
      minuto: null,
      mensaje: '',
      usuario: null,
      nombreEspecial: null,
      password: '',
      base: "CDF",
      cdo: null,
      empleadoServicio: null,
      datosUsuario: {
        data: {
          nombre: null,
          id: null,
        }
      },
      evento: {
        label: 'Menu Principal'
      },
      nombre: null,
      entrar: null,
      layoutMode: 'static',
      layoutColorMode: 'dark',
      staticMenuInactive: false,
      overlayMenuActive: false,
      mobileMenuActive: false,
      ok: 'tru',
      menu: [
        { label: 'Menu Principal', icon: 'pi pi-fw pi-home', to: '/' },
        {
          label: 'Control', icon: 'pi pi-fw pi-clone',
          items: [
            {
              label: 'Actividad', icon: 'pi pi-desktop',
              items: [{ label: 'Rutas Meli', icon: 'pi pi-flag', to: '/ControlRutasMeli' },
              { label: 'Rutas Otros', icon: 'pi pi-flag', to: '/ControlCasaLey' },
              ]
            },
            { label: 'Asistencia', icon: 'pi pi-id-card', to: '/ControlAsistencia' },
            { label: 'Asignaciones', icon: 'pi pi-copy', to: '/ControlAsignaciones' },
          ]
        },
        {
          label: 'Recursos Humanos', icon: 'pi pi-fw pi-users',
          items: [
            { label: 'Registrar Empleado', icon: 'pi pi-user-plus', to: '/ControlAltaEmpleados' },
            { label: 'Generar CFDI Ingreso', icon: 'pi pi-file', to: '/CfdiIngreso' },
          ]
        },
        {
          label: 'Catalogos', icon: 'pi pi-fw pi-users',
          items: [
            { label: 'Tiendas', icon: 'pi pi-user-plus', to: '/catalogos' },
          ]
        },
      ],
      currentDate: new Date(),
      isChangelogVisible: false,
    }
  },
  created() {
    this.empleadoServicio = new EmpleadosServicio();

    // Configurar un objeto Date global para toda la aplicación
    this.setupDateOverride();
  },
  mounted() {
    if (localStorage.tienda != null) {
      this.sesionAb = 1;
    }
    if (localStorage.nombre) {
      this.datosUsuario.data.nombre = localStorage.nombre;
    }
  },
  watch: {
    $route() {
      this.menuActive = false;
      this.$toast.removeAllGroups();
    },
  },
  computed: {
    isAllowedEnvironment() {
      const currentUrl = window.location.href;
      return currentUrl.includes('http://localhost:8081/') ||
        currentUrl.includes('https://webapp.beta-lm.com/');
    }
  },
  methods: {
    sesion(dato) {

      this.sesionAb = dato;
    },

    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
      this.menuClick = false;
    },
    onMenuToggle() {
      this.menuClick = true;
      if (this.isDesktop()) {
        if (this.layoutMode === 'overlay') {
          if (this.mobileMenuActive === true) {
            this.overlayMenuActive = true;
          }
          this.overlayMenuActive = !this.overlayMenuActive;
          this.mobileMenuActive = false;
        } else if (this.layoutMode === 'static') {
          this.staticMenuInactive = !this.staticMenuInactive;
        }
      } else {
        this.mobileMenuActive = !this.mobileMenuActive;
      }
      event.preventDefault();
    },
    onSidebarClick() {
      this.menuClick = true;
    },
    onMenuItemClick(event) {
      this.evento = event.item;
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
    },
    onLayoutChange(layoutMode) {
      this.layoutMode = layoutMode;
    },
    onLayoutColorChange(layoutColorMode) {
      this.layoutColorMode = layoutColorMode;
    },
    addClass(element, className) {
      if (element.classList)
        element.classList.add(className);
      else
        element.className += ' ' + className;
    },
    removeClass(element, className) {
      if (element.classList)
        element.classList.remove(className);
      else
        element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    },
    isDesktop() {
      return window.innerWidth > 1024;
    },
    isSidebarVisible() {
      if (this.isDesktop()) {
        if (this.layoutMode === 'static')
          return !this.staticMenuInactive;
        else if (this.layoutMode === 'overlay')
          return this.overlayMenuActive;
        else
          return true;
      } else {
        return true;
      }
    },
    start() {
      this.tim = 3;
      this.time = 5000;
      this.timer = setInterval(() => {
        if (this.time > 0) {
          this.time--;
        } else if (this.time === 0) {
          clearInterval(this.timer);
          this.cerrarSesion = true;
        }
      }, 1000);
    },
    CerrarLogin() {
      try {

        this.datosUsuario.data.length = 0;
        this.cerrarSesion = false;
        this.sesionAb = 0;

        // Eliminar la marca de changelog al cerrar sesión
        localStorage.removeItem('changelogShown');
        localStorage.clear();
      } catch (error) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: error.message });
      }

    },
    Continuar() {
      this.cerrarSesion = false;
    },
    onLoginSuccess(datosUsuario) {
      this.datosUsuario = datosUsuario;
      this.sesionAb = 1;
      localStorage.setItem('nombre', this.datosUsuario.data.nombre);

      // Verificar si estamos en un entorno permitido
      const isAllowed = this.isAllowedEnvironment;

      // Verificar si ya mostramos el changelog en esta sesión
      const changelogShown = localStorage.getItem('changelogShown');

      if (!changelogShown && isAllowed) {
        // Si no se ha mostrado y estamos en un entorno permitido
        setTimeout(() => {
          this.showChangelogDialog();
          // Marcar como mostrado para esta sesión
          localStorage.setItem('changelogShown', 'true');
        }, 1000); // Pequeño retraso para asegurar que la interfaz esté lista
      }

      this.$router.push('/');
    },
    onDateChanged(date) {
      try {
        // Validación estricta de la fecha
        if (date === null) {
          // Caso de reset: usar la fecha actual
          this.currentDate = new Date();


          try {
            localStorage.removeItem('overrideDate');

          } catch (storageError) {

            sessionStorage.removeItem('overrideDate');
          }
        } else if (date instanceof Date && !isNaN(date.getTime())) {
          // Fecha válida
          this.currentDate = date;


          // Verificar si la fecha está en localStorage
          if (!localStorage.getItem('overrideDate')) {
            try {
              localStorage.setItem('overrideDate', date.toISOString());

            } catch (storageError) {

              // Intentar sessionStorage como alternativa
              sessionStorage.setItem('overrideDate', date.toISOString());
            }
          }
        } else {
          // Fecha inválida

          this.currentDate = new Date();

          try {
            localStorage.removeItem('overrideDate');
          } catch (storageError) {

            sessionStorage.removeItem('overrideDate');
          }
        }

        // Aplicar la sobrescritura de fecha
        this.setupDateOverride();
      } catch (error) {

        this.currentDate = new Date();
        this.setupDateOverride();
      }
    },
    setupDateOverride() {
      try {
        // Asegurarse de guardar las implementaciones originales solo una vez
        if (!window._originalDateNow) {
          window._originalDateNow = Date.now;
        }

        if (!window._originalDate) {
          window._originalDate = window.Date;
        }

        // Verificar si hay una fecha sobreescrita en localStorage o sessionStorage
        let overrideDate = localStorage.getItem('overrideDate');

        // Si no está en localStorage, intentar sessionStorage
        if (!overrideDate) {
          overrideDate = sessionStorage.getItem('overrideDate');

        }



        if (overrideDate) {
          try {
            // Verificar si la fecha está en formato JSON string (doble quotes)
            if (overrideDate.startsWith('"') && overrideDate.endsWith('"')) {
              overrideDate = JSON.parse(overrideDate);
            }

            // Crear objeto Date a partir del string ISO
            const overrideDateObj = new Date(overrideDate);

            // Verificar que la fecha sea válida
            if (isNaN(overrideDateObj.getTime())) {
              throw new Error('Fecha almacenada inválida: ' + overrideDate);
            }

            // Calcular diferencia entre la fecha actual y la sobreescrita
            const actualTime = window._originalDateNow();
            const targetTime = overrideDateObj.getTime();
            const offset = targetTime - actualTime;



            // Sobreescribir Date.now para devolver la hora modificada
            Date.now = function () {
              return window._originalDateNow() + offset;
            };

            // Usar un enfoque más sencillo para reemplazar Date
            // Este enfoque evita problemas con propiedades de solo lectura como 'length'
            const OriginalDate = window._originalDate;

            function CustomDate() {
              // Si no hay argumentos, usar la fecha modificada
              if (arguments.length === 0) {
                return new OriginalDate(Date.now());
              }

              // Manejar el caso de un solo argumento (string o timestamp)
              if (arguments.length === 1) {
                return new OriginalDate(arguments[0]);
              }

              // Para múltiples argumentos, crear un nuevo array y usar apply
              const args = Array.prototype.slice.call(arguments);
              return new (Function.prototype.bind.apply(OriginalDate, [null].concat(args)));
            }

            // Configurar propiedades estáticas seguras
            CustomDate.now = Date.now;
            CustomDate.parse = OriginalDate.parse;
            CustomDate.UTC = OriginalDate.UTC;

            // Propiedades que no se deben intentar modificar
            try {
              Object.defineProperty(CustomDate, 'prototype', {
                value: OriginalDate.prototype,
                writable: false,
                enumerable: false,
                configurable: false
              });
            } catch (protoError) {

              // Continuar de todos modos
            }

            // Reemplazar Date global
            window.Date = CustomDate;



          } catch (error) {

            this.clearDateOverride();
            this.restoreOriginalDate();
          }
        } else {

          // Si no hay override, restaurar implementaciones originales
          this.restoreOriginalDate();
        }
      } catch (error) {

        this.clearDateOverride();
        this.restoreOriginalDate();
      }
    },
    clearDateOverride() {
      try {
        localStorage.removeItem('overrideDate');
      } catch (e) {

      }

      try {
        sessionStorage.removeItem('overrideDate');
      } catch (e) {

      }
    },
    restoreOriginalDate() {
      // Restaurar implementaciones originales
      if (window._originalDateNow) {
        Date.now = window._originalDateNow;
      }

      if (window._originalDate) {
        window.Date = window._originalDate;
      }


    },
    showChangelogDialog() {
      this.isChangelogVisible = true;
    }
  },
  components: {
    'MenuComponent': MenuComponent, // Register the new Menu component
    'Login': Login, // Register the new Login component
    'DateOverride': DateOverride, // Register the DateOverride component
    'AppFooter': AppFooter, // Registrar el componente AppFooter
    'ChangelogDialog': ChangelogDialog
  }
}
</script>

<style scoped>
@import './assets/css/app.css';

/* * {
 background-color: rgba(250, 3, 3, 0.1);
} */


.p-col-12 img {
  width: 300px;
  margin-left: auto;
  margin-right: auto;
  transition: 0.3s;
  opacity: 1;
}

img:hover {
  opacity: 0.8;
}

h5 {
  color: var(--danger-color);
}



.container {
  padding: 2px 16px;
}

.linea,
.linea2 {
  border-top: 2px solid #252526;
  height: 2px;
  max-width: 600px;
  padding: 0;
  margin: 30px auto 0 auto;
  transition: 0.3s;
  box-shadow: none;
}

.linea:hover,
.linea2:hover {
  opacity: 0.8;
}

.p-progressbar .p-progressbar-value {
  background-color: var(--primary-color);
}

.layout-sidebar {
  background-color: var(--sidebar-background-color);
  color: var(--text-color);
}

.layout-sidebar-dark {
  color: var(--dark-text-color);
}

.layout {
  font-family: var(--font-body);
  background-color: var(--background-color);
  display: flex;
  justify-content: flex-start;
  width: 100vw;
  height: 100vh;
  position: relative;
}

.layout-main {

  flex-grow: 1;
  padding: 20px;
  background-color: var(--background-layer);
  overflow: hidden;
  position: relative;
  padding-bottom: 40px;
  /* Espacio para el footer */
}

/* Remove any Bootstrap-specific styles */
</style>
